export var ExperimentationProject;
(function (ExperimentationProject) {
    ExperimentationProject["TEST_PROJECT1"] = "TEST_PROJECT1";
    ExperimentationProject["TEST_PROJECT2"] = "TEST_PROJECT2";
    ExperimentationProject["GROWTH"] = "growth";
    ExperimentationProject["LEGACY_PINS_FLOW"] = "legacyPinsFlow";
})(ExperimentationProject || (ExperimentationProject = {}));
export var TrackingKeys;
(function (TrackingKeys) {
    TrackingKeys["EXPERIMENT_NAME"] = "experimentName";
    TrackingKeys["VARIATION_NAME"] = "variationName";
    TrackingKeys["VARIATION_ID"] = "variationId";
    TrackingKeys["EXPERIMENT_ID"] = "experimentId";
    TrackingKeys["PROJECT_NAME"] = "projectName";
})(TrackingKeys || (TrackingKeys = {}));
export const CLUSTER_ID_KEY = 'clusterId';
//# sourceMappingURL=experimentation.utils.js.map